export const mapRecurrenceTypeFromEnglishToPortuguese = recurrenceType => {
	switch (recurrenceType.toLowerCase()) {
		case 'monthly':
			return 'Mensal'
			break

		case 'yearly':
			return 'Anual'
			break

		case 'annual':
			return 'Anual'
			break

		default:
			break
	}
}
